import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.uuid = uuidv4();

        props.requirePromoMessage(this.uuid, 'card-slider', null);
    }

    shouldComponentUpdate(nextProps) {
        if (
            nextProps.messages != this.props.messages
            &&
            nextProps.messages[this.uuid]
            &&
            nextProps.messages[this.uuid] != this.props.messages[this.uuid]
        ) {
            return true;
        }

        return false;
    }

    render({ messages, logged_in }) {
        if (messages && messages[this.uuid] && messages[this.uuid].message) {
            this.props.trackEvent([
                'Card Slider',
                logged_in ? 'LI Impression' : 'LO Impression',
                'Card Slider',
            ]);

            return (
                <card-slider>
                    <row className='is-aligned-center'>
                        <column className='is-6 is-9-mobile'>
                            <h2>Free Psychic Advice</h2>
                        </column>
                        <column className='is-6 is-3-mobile'>
                            <p><a href='/daily-psychic-advisors'>Powered by Keen</a></p>
                        </column>
                    </row>
                    <div className='slider-arrows'>
                        <a href='#' onClick={(e) => this.slide(e, 'prev')} data-label='prev' />
                        <a href='#' onClick={(e) => this.slide(e, 'next')} data-label='next' />
                    </div>
                    <div
                        className='slider'
                        ref={el => this.el = el}
                        dangerouslySetInnerHTML={{ __html: messages[this.uuid].message }}
                    />
                </card-slider>
            );
        }

        return (<card-slider />);
    }

    renderMessage = (message) => {
        return message;
    }

    slide = (e, dir) => {
        e.preventDefault();

        if (dir == 'next') {
            const first = this.el.querySelector('a:first-of-type');

            first.classList.add('move');

            setTimeout(() => {
                this.el.appendChild(first);
                first.classList.remove('move');
            }, 500);
        } else {
            const last = this.el.querySelector('a:last-of-type');

            last.classList.add('move');
            this.el.prepend(last);

            setTimeout(() => {
                last.classList.remove('move');
            }, 100);
        }
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    messages: state['promo-message'],
});

const mapDispatchToProps = (dispatch) => ({
    requirePromoMessage: (uuid, placement, tags) => dispatch({ type: 'promo-message:require', payload: {
        uuid: uuid,
        placement: placement,
        tags: tags,
    }}),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);